import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
  error?: string;
  helpText?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, id, error, helpText, className, ...props }) => {
  return (
    <div className={`mb-4 ${className}`}>
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            id={id}
            type="checkbox"
            className={`focus:ring-[#b98e4c] h-4 w-4 text-[#b98e4c] border-gray-300 rounded transition duration-150 ${props.disabled ? 'cursor-not-allowed opacity-50' : ''}`}
            {...props}
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor={id} className={`font-medium text-gray-700 ${props.disabled ? 'cursor-not-allowed opacity-70' : ''}`}>
            {label}
          </label>
          {helpText && <p className="text-xs text-gray-500">{helpText}</p>}
        </div>
      </div>
      {error && <p className="mt-1 ml-8 text-xs text-red-600">{error}</p>}
    </div>
  );
};